module.exports = __webpack_public_path__ + "static/media/Merchant User Manual ETAS 2.0.7aa8b761.pdf";